/* eslint-disable */
import is from 'is_js';

const fragment_shader = `precision mediump float;

uniform sampler2D tex;
uniform float texWidth;
uniform float texHeight;

uniform vec3 keyColor;
uniform bool isProcessChromaKey;
uniform float similarity;

vec2 RGBtoUV(vec3 rgb) {
  return vec2(
    rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,
    rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5
  );
}

vec4 ProcessChromaKey(vec2 texCoord) {
  vec4 rgba = texture2D(tex, texCoord);
  if(!isProcessChromaKey){
    return rgba;
  }
  float chromaDist = distance(RGBtoUV(texture2D(tex, texCoord).rgb), RGBtoUV(keyColor));
  if( chromaDist < similarity ){
    rgba.a = 0.;
    rgba.r = 0.;
    rgba.g = 0.;
    rgba.b = 0.;
  }
  return rgba;
}

void main(void) {
  vec2 texCoord = vec2(gl_FragCoord.x/texWidth, 1.0 - (gl_FragCoord.y/texHeight));
  gl_FragColor = ProcessChromaKey(texCoord);
}`;
/**
 *
 * @param {
 * similarity 相似度
 *
 * }
 */
const ChromaKey = function (option) {
  if (!option) return null;
  this.init(option);
  this.destroy = () => {
    this.ended = true;
    clearTimeout(this.timeout);
    this.video.removeEventListener('loadeddata', onLoadedData);
    this.video.removeEventListener('play', onPlay);
    this.video = null;
    this.media = null;
  };
  if (!this.video.paused && this.video.videoWidth !== 0) {
    this.renderVideo();
    return;
  }
  const onLoadedData = () => {
    this.renderVideo();
    this.video.removeEventListener('loadeddata', onLoadedData);
  };
  // if (!this.isChrome) {
  //   this.renderPoster();
  // }
  // this.renderPoster();
  this.video.addEventListener('loadeddata', onLoadedData);

  const onPlay = () => {
    if (!this.video.requestVideoFrameCallback) {
      this.iosRenderVideo();
    }
  };
  this.video.addEventListener('play', onPlay);
};

ChromaKey.prototype.iosThrottle = function () {
  if (this.video.paused || this.video.ended || this.ended) {
    return;
  }
  this.render();
  this.timeout = setTimeout(() => {
    this.iosThrottle();
  }, 20);
};
ChromaKey.prototype.renderVideo = function () {
  const video = this.video;
  // this.setSize(video.videoWidth, video.videoHeight);
  this.media = video;
  const throttle = () => {
    if (!this.media) return null;
    this.render();

    video.requestVideoFrameCallback(throttle);
  };
  if (!video.requestVideoFrameCallback) {
    this.iosRenderVideo();
  } else {
    throttle();
  }
};
ChromaKey.prototype.iosRenderVideo = function () {
  if (!this.video.paused) {
    this.iosThrottle();
  }
  // this.video.addEventListener("play", () => {
  //   this.iosThrottle();
  // });
};

ChromaKey.prototype.renderPosterBak = function () {
  if (!this.poster) return;
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = () => {
    // this.setSize(img.width, img.height);
    if (!this.media) {
      this.media = img;
      this.render();
    }
  };
  img.src = this.poster;
};
ChromaKey.prototype.renderPoster = function (poster, isRender = true) {
  this.poster = poster;
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      if (this.poster === poster) {
        const size = this.setSize(img.width, img.height);
        if (isRender || !this.media) {
          this.media = img;
          this.render();
          if (this.video) {
            this.media = this.video;
          }
        }
        resolve(size);
      } else {
        resolve(false);
      }
    };
    img.src = this.poster;
  });
};
ChromaKey.prototype.setSize = function (_width, _height) {
  let width = _width;
  let height = _height;
  const ratio = width / height;

  if (this.maxWidth && width > this.maxWidth) {
    width = this.maxWidth;
    height = width / ratio;
  }
  if (this.maxHeight && height > this.maxHeight) {
    height = this.maxHeight;
    width = height * ratio;
  }

  this.width = width;
  this.height = height;
  this.canvas.width = width;
  this.canvas.height = height;
  return { width, height };
};
// ChromaKey.prototype.setSize = function (width, height) {
//   const ratio = width / height;

//   if (this.maxWidth && width > this.maxWidth) {
//     width = this.maxWidth;
//     height = width / ratio;
//   }
//   if (this.maxHeight && height > this.maxHeight) {
//     height = this.maxHeight;
//     width = height * ratio;
//   }

//   this.width = width;
//   this.height = height;
//   this.canvas.width = width;
//   this.canvas.height = height;
//   this.onSetSize && this.onSetSize(width, height);
// };
ChromaKey.prototype.render = function () {
  if (!this.media || this.media.currentTime === 0) return;
  const gl = this.gl;
  gl.viewport(0, 0, this.width, this.height);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, this.media);
  gl.uniform1i(this.texLoc, 0);
  gl.uniform1f(this.texWidthLoc, this.width);
  gl.uniform1f(this.texHeightLoc, this.height);
  if (this.keyColorArr) {
    gl.uniform3f(
      this.keyColorLoc,
      this.keyColorArr[0],
      this.keyColorArr[1],
      this.keyColorArr[2]
    );
    gl.uniform1f(this.isProcessChromaKey, true);
  } else {
    gl.uniform1f(this.isProcessChromaKey, false);
  }

  gl.uniform1f(this.similarityLoc, this.similarity);
  gl.drawArrays(gl.TRIANGLE_FAN, 0, 4);
};
ChromaKey.prototype.setKeyColor = function (keyColor) {
  if (!keyColor || keyColor === '') return;
  try {
    const m = keyColor.match(/^#([0-9a-f]{6})$/i)[1];
    this.keyColorArr = [
      Number.parseInt(m.substr(0, 2), 16) / 255,
      Number.parseInt(m.substr(2, 2), 16) / 255,
      Number.parseInt(m.substr(4, 2), 16) / 255,
    ];
  } catch (error) {
    console.error('颜色解析失败', keyColor);
  }
};
ChromaKey.prototype.setSimilarity = function (similarity) {
  this.similarity = Number.parseFloat(similarity);
};
// ChromaKey.prototype.setPoster = function (poster) {
//   if (!this.video.videoWidth) {
//     this.poster = poster;
//     this.renderPoster();
//   }
// };
ChromaKey.prototype.init = function ({
  video,
  canvas,
  keyColor,
  similarity = 0.3,
  poster,
  maxWidth,
  maxHeight,
  onSetSize,
}) {
  this.video = video;
  this.canvas = canvas;
  this.poster = poster;

  this.maxWidth = maxWidth;
  this.maxHeight = maxHeight;
  this.onSetSize = onSetSize;

  this.isChrome = is.chrome();
  this.setKeyColor(keyColor);
  this.setSimilarity(similarity);

  const gl = canvas.getContext('webgl', { premultipliedAlpha: false });
  this.gl = gl;
  const vs = gl.createShader(gl.VERTEX_SHADER);
  gl.shaderSource(
    vs,
    'attribute vec2 c; void main(void) { gl_Position=vec4(c, 0.0, 1.0); }'
  );
  gl.compileShader(vs);
  const fs = gl.createShader(gl.FRAGMENT_SHADER);
  gl.shaderSource(fs, fragment_shader);
  gl.compileShader(fs);
  if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) {
    console.error(gl.getShaderInfoLog(fs));
  }
  const prog = gl.createProgram();
  gl.attachShader(prog, vs);
  gl.attachShader(prog, fs);
  gl.linkProgram(prog);
  gl.useProgram(prog);

  const vb = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, vb);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array([-1, 1, -1, -1, 1, -1, 1, 1]),
    gl.STATIC_DRAW
  );

  const coordLoc = gl.getAttribLocation(prog, 'c');
  gl.vertexAttribPointer(coordLoc, 2, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(coordLoc);

  gl.activeTexture(gl.TEXTURE0);
  const tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);

  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  this.texLoc = gl.getUniformLocation(prog, 'tex');
  this.texWidthLoc = gl.getUniformLocation(prog, 'texWidth');
  this.texHeightLoc = gl.getUniformLocation(prog, 'texHeight');
  this.keyColorLoc = gl.getUniformLocation(prog, 'keyColor');
  this.similarityLoc = gl.getUniformLocation(prog, 'similarity');
  this.isProcessChromaKey = gl.getUniformLocation(prog, 'isProcessChromaKey');
};
let logEl;
function log(text) {
  if (!logEl) {
    logEl = document.createElement('div');
    logEl.style.position = 'absolute';
    logEl.style.top = 0;
    logEl.style.right = 0;
    logEl.style.height = '80vh';
    logEl.style.overflow = 'auto';
    document.body.appendChild(logEl);
    window.logEl = logEl;
  }
  const temp = document.createElement('div');
  temp.innerText = text;
  logEl.appendChild(temp);
  // logEl.innerText = text;
}
export default (options) => {
  return new ChromaKey(options);
};
